import { Link } from "react-router-dom";
import { Ruler, Building2 } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

/**
 * Rooms is now managed per property (Properties → open a property → Rooms tab).
 * This standalone page stays as a signpost so the sidebar link and any old
 * bookmarks still land somewhere useful.
 */
export default function RoomMeasurements() {
  const { t } = useLang();
  return (
    <div data-testid="rooms-page" className="max-w-2xl mx-auto py-16 px-6 text-center">
      <div className="w-14 h-14 mx-auto rounded-full bg-stone-100 flex items-center justify-center text-stone-500 mb-5">
        <Ruler size={24} strokeWidth={1.5} />
      </div>
      <h1 className="font-heading text-3xl font-medium text-stone-900">
        {t("roomsMovedTitle")}
      </h1>
      <p className="text-sm text-stone-500 mt-3 leading-relaxed">
        {t("roomsMovedBody")}
      </p>
      <Link
        to="/properties"
        data-testid="rooms-goto-properties"
        className="inline-flex items-center gap-2 mt-6 bg-stone-900 hover:bg-stone-800 text-white text-sm font-medium rounded-lg px-4 py-2 transition-colors"
      >
        <Building2 size={15} strokeWidth={1.5} />
        {t("openProperties")}
      </Link>
    </div>
  );
}
